<template>
	<div class="product-item">
		<a
			:href="url"
			class="product-item__image-wrapper"
			:title="`Product: ${ title }`"
			:aria-label="`Product: ${ title }`"
			style="--aspect-ratio: 0.6666">
			<transition name="fade">
				<VImg
					v-show="activeImage"
					:media="activeImage"
					:fixedSize="imageSize"
					class="product-item__main-img"
					:customClass="{ 'lazyload': true, 'remove-transition': lazyloaded }"
					@loaded="lazyloaded += 1"
					:key="key"
				/>
			</transition>
			<WishlistButton
				:pid="decode(product.id)"
				:vid="decode(product.variants.edges[0].node.id)"
			/>
		</a>
		<div class="product-item__details">
			<span class="product-item__vendor">
				{{ product.vendor }}
			</span>
			<span class="product-item__title">
				{{ title }}
			</span>
			<p class="product-item__price">
				<span v-text="$money(price)"></span>
				<s
					v-if="salePrice"
					class="product__price--sale"
					v-text="$money(salePrice)">
				</s>
			</p>
			<select
				v-if="product.variants.edges.length > 0"
				class="product-item__select"
				v-model="activeVID">
				<option
					v-for="(variant, idx) in product.variants.edges"
					:value="decode(variant.node.id)"
					:selected="decode(variant.node.id) === activeVID"
					:disabled="!variant.node.availableForSale"
					:key="idx">
					{{ variant.node.title }}
				</option>
			</select>
			<button
				class="wishlist__add-to-cart"
				@click.prevent="addToCart(activeVariant.id); cartLoading = true;"
				:disabled="!activeVariant || !available"
				v-text="cartLoading ? 'adding' : 'add to cart'">
			</button>
		</div>
	</div>
</template>

<script>
import { addItem } from '../../scripts/cart'
import VImg from './VImg'
import WishlistButton from '../Components/WishlistButton'

export default {
	name: 'WishlistItem',

	components: { VImg, WishlistButton },

	props: [
		'product'
	],

	data () {
		return {
			key: 0,
			cartLoading: false,
			lazyloaded: 0,
			imageSize: '550x',
			activeVID: this.decode(this.product.variants.edges[0].node.id)
		}
	},

	computed: {
		title () {
			return this.product.title
		},
		pid () {
			return this.decode(this.product.id)
		},
		vid () {
			return this.decode(this.product.variants.edges[0].node.id)
		},
		vendor () {
			return this.product.vendor
		},
		handle () {
			return this.product.handle
		},
		price () {
			return this.product.variants.edges[0].node.price?.amount
		},
		salePrice () {
			return this.product.variants.edges[0].node.compareAtPrice?.amount
		},
		url () {
			return this.product.onlineStoreUrl
		},
		available () {
			return this.activeVariant.node.availableForSale
		},
		images () {
			let imgs = []
			for (let img of this.product.images.edges) {
				imgs.push({
					width: img.node.width,
					height: img.node.height,
					src: img.node.originalSrc
				})
			}
			return imgs
		},
		activeImage () {
			return this.images.length === 0
				? { src: theme.defaultImage }
				: this.images[1]
		},
		activeVariant () {
			return this.product.variants.edges.find(v => this.decode(v.node.id) == this.activeVID)
		},
		storeLoading () {
			return this.$store.loading
		}
	},

	created () {
		let preloadImages = []
		if (this.images.length) preloadImages.push(this.images[0].src ? this.images[0].src : this.images[0])
		this.$preloadImages(preloadImages, this.imageSize)
	},

	watch: {
		activeImage: {
			handler () {
				this.key = (Math.random() * (999 - 0 + 1)) << 0
			},
			deep: true
		},
		storeLoading () {
			if (this.$store.loading == false) {
				this.cartLoading = false
			}
		}
	},

	methods: {
		addToCart () {
			addItem(this.activeVID)
				.then(() => {
					window.ajaxCart.loadMini()
					let listKey = Object.keys(this.$store.wishlist.list)[0]
					this.$actions.updateWishlist(this.pid, this.vid, true, listKey)
				})
		},
		decode (id) {
			return Number(id.split('/').pop())
		}
	}
}
</script>

<style scoped>
[style*="--aspect-ratio"] > :first-child:not(.wishlist-btn) {
	width: 100%;
	object-fit: cover;
}

[style*="--aspect-ratio"].contain {
	background: var(--light-grey);
}

[style*="--aspect-ratio"] > :first-child {
	object-fit: contain;
}

[style*="--aspect-ratio"] > img {
	height: auto;
}

@supports (--custom:property) {
	[style*="--aspect-ratio"] {
		position: relative;
		display: block;
		padding: calc(100% / var(--aspect-ratio)) 0 0;
	}

	[style*="--aspect-ratio"] > :first-child:not(.wishlist-btn) {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
